{
  "runStatus": {
    "DRAFT": "مسودة",
    "CALCULATED": "محتسب",
    "APPROVED": "معتمد",
    "PAID": "مصروف",
    "CANCELLED": "ملغى",
    "REVERSED": "معكوس"
  },
  "ruleStatus": {
    "ACTIVE": "ساري",
    "SCHEDULED": "مجدول",
    "ENDED": "منتهٍ",
    "OFF": "متوقف"
  },
  "scope": {
    "OMANI": "الموظفون العمانيون",
    "NON_OMANI": "الموظفون غير العمانيين",
    "ALL": "كل الموظفين"
  },
  "base": {
    "CONTRIBUTORY": "أجر الاشتراك",
    "BASIC": "الراتب الأساسي",
    "GROSS": "إجمالي الاستحقاقات"
  },
  "baseHint": {
    "CONTRIBUTORY": "العناصر المحددة بأنها تدخل في أجر الاشتراك، بعد خصم أيام الغياب دون أجر.",
    "BASIC": "الراتب الأساسي بعد خصم أيام الغياب دون أجر.",
    "GROSS": "كل استحقاقات الشهر."
  },
  "dayRateBasis": {
    "FIXED_30": "الشهر 30 يومًا",
    "CALENDAR": "عدد أيام الشهر"
  },
  "wageBasis": {
    "BASIC": "الراتب الأساسي",
    "GROSS": "إجمالي الراتب"
  },
  "gratuityScope": {
    "NON_OMANI": "الموظفون غير العمانيين",
    "ALL": "كل الموظفين"
  },
  "kind": {
    "EARNING": "استحقاق",
    "DEDUCTION": "استقطاع"
  },
  "payMethod": {
    "BANK": "تحويل بنكي (حماية الأجور)",
    "CASH": "نقدًا",
    "CHEQUE": "شيك"
  },
  "severity": {
    "ERROR": "خطأ",
    "WARNING": "تنبيه",
    "INFO": "ملاحظة"
  },
  "alerts": {
    "NO_SALARY": "لا يوجد راتب مسجل لهذا الشهر: لا يمكن صرف شيء.",
    "NO_BASIC": "لا يتضمن الراتب راتبًا أساسيًا: قد تكون الاشتراكات ومكافأة نهاية الخدمة غير صحيحة.",
    "NET_NEGATIVE": "صافي الراتب أقل من صفر ({{net}}): خفّض الاستقطاعات.",
    "MINIMUM_WAGE": "أقل من الحد الأدنى للأجور للعمانيين: الإجمالي {{total}} (الحد الأدنى {{minimumTotal}})، والأساسي {{basic}} (الحد الأدنى {{minimumBasic}}).",
    "DEDUCTION_CAP": "الاستقطاعات الاختيارية {{deductions}} تتجاوز الحد الأعلى {{cap}}.",
    "CEILING_APPLIED": "احتُسبت الاشتراكات على الحد الأعلى {{ceiling}} لا على الأجر {{wage}}.",
    "MISSING_BANK_DETAILS": "يُصرف الراتب بنكيًا لكن رمز البنك أو رقم الآيبان غير موجود، وملف حماية الأجور يحتاجهما.",
    "MISSING_CIVIL_ID": "لا يوجد رقم البطاقة المدنية أو الإقامة، وملف حماية الأجور يحتاجه.",
    "SUSPENDED": "موقوف في هذا الشهر: لا يُصرف له راتب أثناء الإيقاف.",
    "NO_CONTRIBUTION_RULES": "لا ينطبق عليه أي بند اشتراك: راجع نسب الاشتراكات.",
    "ENDS_IN_PERIOD": "يغادر في {{date}}: يُصرف له حتى ذلك اليوم مع تسوية مستحقات نهاية الخدمة.",
    "JOINS_IN_PERIOD": "عُيّن في {{date}}: يُصرف له من ذلك اليوم."
  },
  "runs": {
    "title": "كشوف الرواتب",
    "subtitle": "كشف لكل شهر: احتساب ثم اعتماد ثم صرف",
    "new": "كشف رواتب جديد",
    "newTitle": "كشف رواتب جديد",
    "newBody": "يصرف الكشف رواتب موظفي الشهر مع المدخلات التي تسجلها قبل احتسابه.",
    "create": "إنشاء الكشف",
    "created": "أُنشئ كشف رواتب {{period}}",
    "month": "الشهر",
    "year": "السنة",
    "payDate": "تاريخ الصرف",
    "payDateHint": "اليوم الذي تصل فيه الرواتب إلى البنوك.",
    "note": "ملاحظة",
    "fields": {
      "period": "الشهر",
      "payDate": "تاريخ الصرف",
      "status": "الحالة",
      "employees": "الموظفون",
      "gross": "الإجمالي",
      "deductions": "الاستقطاعات",
      "net": "الصافي",
      "employerCost": "تكلفة صاحب العمل"
    },
    "filters": {
      "status": "الحالة",
      "allStatuses": "كل الحالات",
      "year": "السنة",
      "allYears": "كل السنوات"
    },
    "empty": {
      "title": "لا توجد كشوف رواتب بعد",
      "body": "أنشئ أول كشف رواتب.",
      "filteredTitle": "لا يوجد كشف مطابق",
      "filteredBody": "غيّر عوامل التصفية."
    }
  },
  "run": {
    "title": "كشف الرواتب",
    "backToList": "العودة إلى كشوف الرواتب",
    "payDate": "تاريخ الصرف {{date}}",
    "calculated": "احتُسب في {{at}} بواسطة {{name}}",
    "approved": "اعتُمد في {{at}} بواسطة {{name}}",
    "paid": "صُرف في {{date}} من {{account}}",
    "journal": "قيد الرواتب",
    "paymentJournal": "قيد الصرف",
    "staleTitle": "حدث تغيير منذ الاحتساب",
    "staleBody": "تغيّر الموظفون أو الرواتب أو المدخلات أو بنود الاشتراكات أو الإعدادات، أو اعتُمد كشف شهر سابق أو عُكس، بعد احتساب هذا الكشف. أعد الاحتساب قبل الاعتماد.",
    "CANCELLED": "أُلغي في {{date}}",
    "REVERSED": "عُكس في {{date}}: عُكس قيد الرواتب",
    "alertsTitle": "{{errors}} أخطاء · {{warnings}} تنبيهات",
    "errorsBody": "قسيمة الراتب التي فيها خطأ تمنع الاعتماد.",
    "warningsBody": "التنبيهات لا تمنع الاعتماد؛ راجعها قبل أن تعتمد.",
    "seeAlerts": "عرض التنبيهات",
    "totals": "إجماليات الكشف"
  },
  "totals": {
    "employees": "الموظفون",
    "gross": "الإجمالي",
    "deductions": "الاستقطاعات",
    "employeeContributions": "اشتراكات الموظفين",
    "net": "صافي الرواتب",
    "employerContributions": "اشتراكات صاحب العمل",
    "gratuityProvision": "مخصص المكافأة",
    "gratuityPaid": "المكافأة المصروفة",
    "employerCost": "تكلفة صاحب العمل"
  },
  "actions": {
    "calculate": "احتساب",
    "recalculate": "إعادة الاحتساب",
    "approve": "اعتماد",
    "pay": "تسجيل الصرف",
    "wps": "تنزيل ملف حماية الأجور",
    "edit": "تعديل تاريخ الصرف",
    "cancel": "إلغاء الكشف",
    "reverse": "عكس"
  },
  "calculate": {
    "running": "جارٍ الاحتساب…",
    "toast": "احتُسب كشف رواتب {{period}}"
  },
  "approve": {
    "title": "اعتماد كشف رواتب {{period}}؟",
    "body": "الاعتماد يقفل الكشف: لا تتغير قسائم الرواتب بعده، ويُرحّل قيد الرواتب إلى دفتر الأستاذ.",
    "confirm": "اعتماد وترحيل",
    "toast": "اعتُمد كشف رواتب {{period}}",
    "staleReason": "حدث تغيير منذ الاحتساب: أعد الاحتساب أولًا.",
    "errorsReason": "أخطاء قسائم الرواتب ({{n}}) تمنع الاعتماد."
  },
  "pay": {
    "title": "تسجيل صرف الرواتب",
    "body": "التاريخ الذي صرف فيه البنك الرواتب والحساب الذي صُرفت منه. يُرحّل قيد الصرف.",
    "paidOn": "تاريخ الصرف",
    "account": "صُرفت من",
    "accountHint": "الحساب النقدي أو البنكي الذي صُرفت منه الرواتب.",
    "chooseAccount": "اختر حسابًا",
    "loadingAccounts": "جارٍ تحميل الحسابات…",
    "reference": "مرجع البنك",
    "confirm": "تسجيل الصرف",
    "toast": "سُجّل صرف رواتب {{period}}"
  },
  "reverse": {
    "title": "عكس كشف رواتب {{period}}",
    "body": "يُعكس قيد الرواتب ويمكن إعداد كشف جديد للشهر. لا تفعل ذلك إلا قبل صرف الرواتب.",
    "reason": "السبب",
    "confirm": "عكس الكشف",
    "toast": "عُكس كشف رواتب {{period}}"
  },
  "cancel": {
    "title": "إلغاء كشف رواتب {{period}}",
    "body": "يُستبعد الكشف ويمكن إعداد كشف جديد للشهر.",
    "reason": "السبب",
    "confirm": "إلغاء الكشف",
    "toast": "أُلغي كشف رواتب {{period}}"
  },
  "edit": {
    "title": "تعديل تاريخ الصرف والملاحظة",
    "confirm": "حفظ",
    "toast": "حُفظ الكشف"
  },
  "wps": {
    "downloading": "جارٍ التنزيل…"
  },
  "tabs": {
    "label": "كشف الرواتب",
    "payslips": "قسائم الرواتب",
    "inputs": "المدخلات",
    "contributions": "الاشتراكات",
    "alerts": "التنبيهات"
  },
  "payslips": {
    "employee": "الموظف",
    "paidDays": "أيام الصرف",
    "basic": "الأساسي",
    "gross": "الإجمالي",
    "deductions": "الاستقطاعات",
    "employeeContributions": "الاشتراكات",
    "net": "الصافي",
    "alerts": "التنبيهات",
    "searchPlaceholder": "اسم الموظف أو رقمه",
    "searchLabel": "البحث في قسائم الرواتب",
    "clearSearch": "مسح البحث",
    "emptySearch": "لا توجد قسيمة مطابقة",
    "notCalculated": "لم يُحتسب بعد",
    "notCalculatedBody": "احتسب الكشف لإنشاء قسائم الرواتب."
  },
  "inputs": {
    "intro": "الغياب والعمل الإضافي والبنود المؤقتة لهذا الشهر. حفظ أي منها يستلزم إعادة احتساب الكشف.",
    "closed": "الكشف مغلق: لا يمكن تعديل مدخلاته.",
    "add": "إضافة مدخلات",
    "addTitle": "إضافة مدخلات",
    "editTitle": "تعديل المدخلات",
    "body": "أيام الشهر وساعاته، والبنود المؤقتة من العناصر المتغيرة.",
    "edit": "تعديل",
    "remove": "حذف",
    "removeTitle": "حذف هذه المدخلات؟",
    "removeBody": "يُصرف للموظف دونها عند الاحتساب التالي.",
    "removedToast": "حُذفت المدخلات",
    "actions": "إجراءات المدخلات",
    "save": "حفظ المدخلات",
    "toast": "حُفظت المدخلات؛ أعد احتساب الكشف",
    "employee": "الموظف",
    "days": "الأيام",
    "overtime": "العمل الإضافي",
    "adjustments": "البنود المؤقتة",
    "noAdjustments": "لا توجد بنود مؤقتة.",
    "component": "العنصر",
    "chooseComponent": "اختر عنصرًا",
    "amount": "المبلغ",
    "lineNote": "ملاحظة",
    "addLine": "إضافة بند",
    "removeLine": "حذف البند",
    "empty": "لا توجد مدخلات لهذا الكشف.",
    "unpaidShort": "{{n}} دون أجر",
    "sickShort": "{{n}} مرضية",
    "encashShort": "{{n}} مستبدلة نقدًا",
    "overtimeShort": "{{n}} س نهاري",
    "nightShort": "{{n}} س ليلي / راحة / عطلة",
    "fields": {
      "unpaidDays": "أيام الغياب دون أجر",
      "sickDays": "أيام الإجازة المرضية",
      "overtimeHours": "ساعات العمل الإضافي",
      "overtimeNightHours": "ساعات العمل الإضافي الليلي وأيام الراحة والعطلات",
      "encashmentDays": "أيام الإجازة المصروفة نقدًا",
      "note": "ملاحظة"
    }
  },
  "contributions": {
    "title": "جدول اشتراكات صندوق الحماية الاجتماعية",
    "intro": "أجر الاشتراك لكل موظف، وحصتا الموظف وصاحب العمل في كل بند.",
    "csv": "تنزيل CSV",
    "employee": "الموظف",
    "wage": "أجر الاشتراك",
    "total": "الإجمالي",
    "employeeShare": "الموظف",
    "employerShare": "صاحب العمل",
    "totals": "الإجمالي لعدد {{n}} من الموظفين",
    "empty": "لا توجد اشتراكات في هذا الكشف."
  },
  "alertsTab": {
    "ERROR": "الأخطاء",
    "WARNING": "التنبيهات",
    "INFO": "الملاحظات",
    "none": "لم يجد الاحتساب ما يستدعي التنبيه.",
    "runLevel": "الكشف كله"
  },
  "payslip": {
    "title": "قسيمة الراتب",
    "back": "العودة إلى كشف رواتب {{period}}",
    "period": "الشهر",
    "payDate": "تاريخ الصرف",
    "employee": "الموظف",
    "civilNumber": "الرقم المدني",
    "spfNumber": "رقم صندوق الحماية الاجتماعية",
    "hireDate": "تاريخ التعيين",
    "payMethod": "طريقة الصرف",
    "iban": "الآيبان",
    "days": "أيام الشهر",
    "employed": "مدة العمل",
    "daysInPeriod": "أيام الشهر",
    "paidDays": "أيام الصرف",
    "unpaidDays": "أيام دون أجر",
    "sickDays": "أيام مرضية",
    "overtimeHours": "ساعات العمل الإضافي",
    "overtimeNightHours": "عمل إضافي ليلي / راحة / عطلة",
    "earnings": "الاستحقاقات",
    "deductions": "الاستقطاعات",
    "gross": "إجمالي الاستحقاقات",
    "totalDeductions": "إجمالي الاستقطاعات",
    "net": "صافي الراتب",
    "employer": "يدفعه صاحب العمل",
    "employerNote": "يدفعه صاحب العمل إضافة إلى الراتب ولا يُستقطع منه.",
    "totalEmployer": "إجمالي اشتراكات صاحب العمل",
    "item": "البند",
    "amount": "المبلغ",
    "none": "لا يوجد",
    "alerts": "التنبيهات",
    "hours": "س",
    "daysShort": "يوم",
    "percentOf": "{{rate}}% من {{base}}",
    "footer": "المبالغ بالريال العماني (<rial/>).",
    "commissionStatement": "فتح بيان العمولة"
  },
  "rules": {
    "title": "نسب الاشتراكات",
    "subtitle": "نسب صندوق الحماية الاجتماعية لكل فرع، للموظفين العمانيين وغير العمانيين",
    "noteTitle": "هذه النسب بيانات خاصة بالشركة",
    "noteBody": "كل بند نسبة تحتفظ بها الشركة. راجعها مع النسب السارية لدى صندوق الحماية الاجتماعية؛ أي تغيير في القانون يُضاف صفًا جديدًا من تاريخ سريانه، ولا يُعدَّل صف طُبّق.",
    "add": "إضافة بند",
    "addTitle": "إضافة بند اشتراك",
    "edit": "تعديل",
    "editTitle": "تعديل {{code}}",
    "save": "حفظ البند",
    "delete": "حذف",
    "deleteTitle": "حذف {{code}}؟",
    "deleteBody": "يُحذف البند، وتحتفظ الكشوف المعتمدة بما احتسبته.",
    "deletedToast": "حُذف {{code}}",
    "addedToast": "أُضيف {{code}}",
    "savedToast": "حُفظ {{code}}",
    "loadPreset": "تحميل البنود العمانية",
    "presetToast_zero": "لم يُحمّل أي بند",
    "presetToast_one": "حُمّل بند واحد",
    "presetToast_two": "حُمّل بندان",
    "presetToast_few": "حُمّلت {{n}} بنود",
    "presetToast_many": "حُمّل {{n}} بندًا",
    "presetToast_other": "حُمّل {{n}} بند",
    "inUse": "طُبّق في كشف رواتب",
    "inUseReason": "طُبّق في كشف رواتب معتمد: أنهِ سريانه بدلًا من حذفه.",
    "inUseNote": "طُبّق هذا البند في كشف رواتب معتمد: يبقى رمزه ونطاقه ونسبه وأساسه وحده الأعلى وتاريخ بدئه كما هي. أنهِ سريانه وأضف بندًا جديدًا للنسبة الجديدة.",
    "actionsFor": "إجراءات {{code}}",
    "scopeEmpty": "لا توجد بنود لهؤلاء الموظفين.",
    "ceilingShort": "حتى",
    "noEnd": "دون نهاية",
    "employeeRateHint": "تُستقطع من راتب الموظف، بالنسبة المئوية.",
    "employerRateHint": "يدفعها صاحب العمل إضافة إلى الراتب، بالنسبة المئوية.",
    "ceilingHint": "أعلى أساس شهري تُطبّق عليه النسب؛ فارغ: دون حد أعلى.",
    "effectiveToHint": "فارغ: ساري حتى إنهائه.",
    "fields": {
      "code": "الرمز",
      "name": "البند",
      "nameEn": "الاسم بالإنجليزية",
      "nameAr": "الاسم بالعربية",
      "scope": "تنطبق على",
      "employeeRate": "نسبة الموظف %",
      "employerRate": "نسبة صاحب العمل %",
      "base": "الأساس",
      "ceiling": "الحد الأعلى",
      "dates": "السريان",
      "effectiveFrom": "من",
      "effectiveTo": "حتى",
      "source": "المصدر",
      "status": "الحالة",
      "active": "مفعّل"
    },
    "empty": {
      "title": "لا توجد بنود اشتراك بعد",
      "body": "حمّل البنود العمانية ثم راجع كل نسبة مع صندوق الحماية الاجتماعية."
    }
  },
  "settings": {
    "title": "إعدادات الرواتب",
    "subtitle": "كيف تُصرف الرواتب وما الذي يُراجع",
    "updated": "آخر تغيير في {{at}} بواسطة {{name}}",
    "readOnlyTitle": "للقراءة فقط",
    "readOnlyBody": "تغيير إعدادات الرواتب يحتاج إلى صلاحية إعدادات الرواتب.",
    "save": "حفظ الإعدادات",
    "discard": "تجاهل التغييرات",
    "saved": "حُفظت إعدادات الرواتب",
    "fix": "بعض الحقول تحتاج إلى مراجعة.",
    "notSaved": "لم يُحفظ",
    "conflict": "غيّر شخص آخر الإعدادات في الأثناء. أعد تحميل الصفحة لرؤية نسخته.",
    "wps": {
      "title": "نظام حماية الأجور",
      "body": "صاحب العمل والجهة الدافعة في ملف حماية الأجور.",
      "employerCr": "رقم السجل التجاري لصاحب العمل",
      "employerCrHint": "فارغ: رقم السجل التجاري في ملف الشركة.",
      "payerBankCode": "رمز بنك الجهة الدافعة",
      "payerAccount": "حساب الجهة الدافعة"
    },
    "days": {
      "title": "أيام الصرف",
      "dayRateBasis": "أجر اليوم",
      "basisHint": {
        "FIXED_30": "أجر الشهر مقسومًا على 30 أيًا كان الشهر (الممارسة العمانية).",
        "CALENDAR": "أجر الشهر مقسومًا على عدد أيام ذلك الشهر."
      },
      "encashmentBase": "أجر استبدال الإجازة",
      "encashmentHint": "يوم الإجازة المصروف نقدًا يساوي هذا الأجر مقسومًا على 30."
    },
    "overtime": {
      "title": "العمل الإضافي",
      "base": "أجر العمل الإضافي",
      "divisor": "ساعات الشهر",
      "divisorHint": "أجر الساعة هو أجر العمل الإضافي مقسومًا على هذا العدد (240 = 30 يومًا × 8 ساعات).",
      "dayRate": "معدل العمل الإضافي النهاري",
      "dayRateHint": "× 1.25 وفق قانون العمل.",
      "nightRate": "معدل الليل وأيام الراحة والعطلات",
      "nightRateHint": "× 1.5 وفق قانون العمل.",
      "contributory": "يدخل العمل الإضافي في أجر الاشتراك"
    },
    "sick": {
      "title": "الإجازة المرضية",
      "body": "أجر أيام المرض خلال السنة على شرائح؛ الأيام بعد آخر شريحة دون أجر.",
      "toDay": "حتى اليوم",
      "payPercent": "نسبة الأجر %",
      "add": "إضافة شريحة",
      "remove": "حذف الشريحة"
    },
    "gratuity": {
      "title": "مكافأة نهاية الخدمة",
      "body": "يُكوَّن لها مخصص كل شهر، وتُصرف في شهر مغادرة الموظف.",
      "enabled": "صرف مكافأة نهاية الخدمة",
      "scope": "من يستحقها",
      "minService": "الحد الأدنى للخدمة (بالسنوات)",
      "minServiceHint": "دونه لا يُصرف شيء عند المغادرة، ويستمر تكوين المخصص.",
      "accrualUntil": "تُستحق حتى",
      "accrualUntilHint": "الخدمة بعد هذا التاريخ لا تستحق مكافأة (يحل محلها نظام الادخار).",
      "proRata": "تُحتسب أجزاء السنة بنسبتها",
      "tiers": "أيام الأجر عن كل سنة خدمة",
      "fromYear": "من السنة",
      "daysPerYear": "أيام في السنة",
      "addTier": "إضافة شريحة",
      "removeTier": "حذف الشريحة"
    },
    "checks": {
      "title": "المراجعات",
      "minimumWage": "الحد الأدنى لأجور العمانيين (الإجمالي)",
      "minimumHint": "تُعلَّم القسائم التي تقل عنه؛ 0 يوقف هذه المراجعة.",
      "minimumBasic": "الحد الأدنى للراتب الأساسي للعمانيين",
      "deductionCap": "الحد الأعلى للاستقطاعات %",
      "deductionCapHint": "تُعلَّم الاستقطاعات الاختيارية التي تتجاوز هذه النسبة من الإجمالي.",
      "makerChecker": "من يحتسب الكشف لا يعتمده",
      "makerCheckerHint": "مبدأ الفصل: يحتاج الاعتماد إلى شخص ثانٍ."
    }
  },
  "validation": {
    "percent": "أدخل نسبة بأربع خانات عشرية على الأكثر",
    "atMost100": "100 على الأكثر",
    "rate": "أدخل معدلًا بخانتين عشريتين على الأكثر",
    "rateRange": "بين 1 و5",
    "number": "أدخل رقمًا بخانتين عشريتين على الأكثر",
    "hours": "أدخل الساعات بخانتين عشريتين على الأكثر",
    "atLeastOne": "1 على الأقل",
    "bandOrder": "يجب أن تأتي بعد الشريحة السابقة",
    "firstTier": "تبدأ الشريحة الأولى من 0",
    "tierOrder": "يجب أن تأتي بعد الشريحة السابقة",
    "ruleCode": "استخدم من 2 إلى 40 حرفًا لاتينيًا أو رقمًا أو شرطة سفلية، يبدأ بحرف",
    "someRate": "أدخل نسبة الموظف أو نسبة صاحب العمل",
    "endBeforeStart": "ينتهي قبل أن يبدأ",
    "positive": "يجب أن يكون أكبر من صفر"
  },
  "errors": {
    "PAYROLL_PERIOD_TAKEN": "لهذا الشهر كشف رواتب قائم. ألغِه أو اعكسه أولًا.",
    "PAYROLL_RUN_STATUS": "لا يمكن تنفيذ ذلك في حالة الكشف الحالية. أعد تحميل الصفحة لرؤيتها.",
    "PAYROLL_NOT_CALCULATED": "احتسب الكشف قبل اعتماده.",
    "PAYROLL_STALE": "حدث تغيير منذ الاحتساب. أعد الاحتساب ثم اعتمد.",
    "PAYROLL_HAS_ERRORS": "في إحدى قسائم الرواتب خطأ (لا راتب، أو صافٍ أقل من صفر). صحّحه وأعد الاحتساب.",
    "PAYROLL_SAME_PERSON": "أنت من احتسب هذا الكشف، فيجب أن يعتمده شخص آخر.",
    "TREASURY_ACCOUNT_INVALID": "اختر حسابًا نقديًا أو بنكيًا نشطًا صُرفت منه الرواتب.",
    "WPS_NOT_SET_UP": "يحتاج ملف حماية الأجور إلى رقم السجل التجاري لصاحب العمل وبنك الجهة الدافعة وحسابها. أدخلها في إعدادات الرواتب.",
    "PAYROLL_EMPLOYEE_NOT_IN_PERIOD": "هذا الموظف ليس على رأس العمل في شهر الكشف.",
    "PAYROLL_OUT_OF_ORDER": "تُعتمد الأشهر بالترتيب: اعتمد كشف الشهر السابق أو ألغه أولًا، أو اعكس كشف الشهر اللاحق أولًا.",
    "CONTRIBUTION_RULE_IN_USE": "طُبّق هذا البند في كشف رواتب معتمد: لا يمكن تغيير نسبه وتواريخه. أنهِ سريانه وأضف بندًا جديدًا.",
    "CONTRIBUTION_RULE_DUPLICATE": "لبند آخر الرمز نفسه من التاريخ نفسه."
  }
}
